import { LoginAsComponent } from './login-as/login-as.component';
import { OuterFooterModule } from './../shared/outer-footer/outer-footer.module';
import { NotFoundRoutingModule } from './../not-found/not-found.routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from './register/register.component';
import { LoginComponent } from './login/login.component';
import { AuthenticationRoutingModule } from './authentication.routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedTranslateLazyModule } from '../shared/shared-translate-lazy.module';
import { CommonUtilityModule } from '../shared/common-utility.module';

import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LeftMenuModule } from '../shared/left-menu.module';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { RegistrationSuccessComponent } from './registration-success/registration-success.component';


@NgModule({
  declarations: [RegisterComponent, LoginComponent,  ForgotPasswordComponent, ActivateUserComponent, RegistrationSuccessComponent,LoginAsComponent],
  imports: [
    CommonModule,
    LeftMenuModule,
     AuthenticationRoutingModule,
    NotFoundRoutingModule,
    SharedTranslateLazyModule,
    ReactiveFormsModule,CommonUtilityModule,OuterFooterModule
  ]
})
export class AuthenticationModule { }
